import React from 'react';
import {
    TableCell,
    TableRow,
    TextField
} from 'material-ui';
import {
    showViewTranslationButton,
    canEditOrViewTranslation
} from '../../../components/permissions/permissions';
import TagTranslationsTableItemActions from './TagTranslationsTableItemActions';

class TagTranslationsTableContent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editing: false
        };
    };

    onClickEditField = () => {
        this.setState({
            editing: true
        });
        
        this.props.getTranslationForSite(this.props.site.id);
    };

    cancelUpdateTagTranslation = () => {
        this.setState({
            editing: false
        });
    };

    render() {
        const {
            classes,
            tag,
            site,
            tagTranslation,
            handleClick,
            handleClickOpen,
            createTagTranslation,
            updateTagTranslation,
            editTextFieldInline,
            addTextFieldInline,
            tagTranslationBySite,
            newTranslated
        } = this.props;

        const ShowEditableTranslationField = () => (
            <TableCell width={370} className={classes.tableCellEditable} onClick={this.onClickEditField}>
                {this.state.editing
                    ? <TextField
                        name={"display-name-" + site.id}
                        disabled={tagTranslation !== null ? site.id !== tagTranslationBySite.site_id : site.id !== newTranslated.site_id}
                        className={classes.editTextFieldInline}
                        value={tagTranslation !== null
                            ? (site.id === tagTranslationBySite.site_id
                                ? tagTranslationBySite.display_name
                                : tagTranslation.display_name)
                            : (site.id === newTranslated.site_id
                                ? newTranslated.display_name
                                : 'Add the translation for the tag name here...')
                            }
                        onChange={(ev) => {
                            if (tagTranslation === null) {
                                addTextFieldInline(ev.target.value, site.id);
                            }
                            if (tagTranslation !== null) {
                                editTextFieldInline(ev.target.value);
                            }
                            
                        }}
                        placeholder={tagTranslation ? tagTranslation.display_name : 'Add the translation for the tag name here...'}
                        fullWidth
                        autoFocus
                    />
                    : tagTranslation !== null ? tagTranslation.display_name : 'There are no translations for this website yet! Click here to add a translation for this tag name!'
                }
            </TableCell>
        )

        const ShowNotEditableTranslationField = showViewTranslationButton(() =>
            <TableCell width={370} className={classes.tableCell}>{tagTranslation !== null ? tagTranslation.display_name : 'There are no translations for this website!'}</TableCell>
        )

        let EditOrViewTranslation = canEditOrViewTranslation(ShowEditableTranslationField, ShowNotEditableTranslationField);

        return (
            <TableRow hover={true}>
                <TableCell className={classes.tableCell}>{tagTranslation !== null ? tagTranslation.id : '-'}</TableCell>
                <TableCell className={classes.tableCell}>{site.id}</TableCell>
                <TableCell className={classes.tableCell}>{site.display_name}</TableCell>
                <EditOrViewTranslation />
                <TagTranslationsTableItemActions
                    tag={tag}
                    siteId={site.id}
                    newTranslated={newTranslated}
                    classes={classes}
                    editing={this.state.editing}
                    tagTranslation={tagTranslation}
                    tagTranslationBySite={tagTranslationBySite}
                    handleClick={handleClick}
                    handleClickOpen={handleClickOpen}
                    updateTagTranslation={updateTagTranslation}
                    createTagTranslation={createTagTranslation}
                    cancelUpdateTagTranslation={this.cancelUpdateTagTranslation}
                />
            </TableRow>
        )
    }
}

export default TagTranslationsTableContent;


// WEBPACK FOOTER //
// ./src/containers/tags/translations/TagTranslationsTableItem.jsx